/** 增加PC端支持 20250714 
 * 产品页折叠块粘性标题功能 (优化版)
 * 适用于Shopify Dawn主题
 */

class StickyAccordion {
  constructor() {
    this.accordions = [];
    this.headerHeight = 0;
    this.isInitialized = false;
    this.resizeObserver = null;
    this.intersectionObservers = new Map(); // 使用Map存储每个折叠块的IntersectionObserver
    this.accordionPositions = new Map(); // 存储折叠块的原始位置
    
    // 绑定方法
    this.handleToggle = this.handleToggle.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.updateHeaderHeight = this.updateHeaderHeight.bind(this);
    
    this.init();
  }

  init() {
    // 移除移动端限制，使功能在所有屏幕尺寸下生效
    // if (window.innerWidth > 750) {
    //   return;
    // }

    // 等待DOM加载完成
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setup());
    } else {
      this.setup();
    }
  }

  setup() {
    // 查找所有产品折叠块
    this.accordions = document.querySelectorAll('.product__accordion details');
    
    if (this.accordions.length === 0) {
      return;
    }

    // 初始化Header高度
    this.updateHeaderHeight();
    
    // 记录每个折叠块的初始位置
    this.recordAccordionPositions();
    
    // 为每个折叠块添加事件监听
    this.accordions.forEach(accordion => {
      accordion.addEventListener('toggle', this.handleToggle);
      // 检查默认展开的折叠块并激活粘性效果
      if (accordion.open) {
        this.activateSticky(accordion.closest('.product__accordion'));
      }
      // 为每个折叠块的summary元素创建IntersectionObserver
      this.setupIntersectionObserver(accordion.closest('.product__accordion'));
    });

    // 添加滚动监听（节流处理）
    this.addScrollListener();
    
    // 添加窗口大小变化监听
    window.addEventListener('resize', this.handleResize);
    
    // 监听Header高度变化
    this.observeHeaderChanges();
    
    // 设置CSS变量
    this.setCSSVariables();
    
    this.isInitialized = true;
    
    console.log('StickyAccordion initialized with', this.accordions.length, 'accordions');
  }

  recordAccordionPositions() {
    // 记录每个折叠块的初始位置，用于收起时的滚动优化
    this.accordions.forEach(accordion => {
      const container = accordion.closest('.product__accordion');
      if (container) {
        const rect = container.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        this.accordionPositions.set(container, scrollTop + rect.top);
      }
    });
  }

  updateHeaderHeight() {
    // 尝试多种方式获取Header高度
    const header = document.querySelector('header.header') || 
                   document.querySelector('.header') || 
                   document.querySelector('header') ||
                   document.querySelector('.shopify-section-header');
    
    if (header) {
      this.headerHeight = header.offsetHeight;
    } else {
      // 默认高度
      this.headerHeight = 60;
    }
    
    // 更新CSS变量
    document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);
  }

  setCSSVariables() {
    document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);
  }

  handleToggle(event) {
    const accordion = event.target;
    const accordionContainer = accordion.closest('.product__accordion');
    
    if (!accordionContainer) return;

    if (accordion.open) {
      // 折叠块展开
      this.activateSticky(accordionContainer);
      
      // 延迟滚动到折叠块位置，确保动画完成
      setTimeout(() => {
        this.scrollToAccordion(accordionContainer);
      }, 100);
    } else {
      // 折叠块收起 - 优化滚动位置
      this.deactivateSticky(accordionContainer);
      this.optimizeScrollOnCollapse(accordionContainer);
    }
  }

  activateSticky(accordionContainer) {
    // 激活当前折叠块的粘性状态
    // 不再移除其他折叠块的粘性状态，让每个折叠块独立判断
    accordionContainer.classList.add('sticky-active');
  }

  deactivateSticky(accordionContainer) {
    accordionContainer.classList.remove('sticky-active', 'is-sticky');
  }

  optimizeScrollOnCollapse(accordionContainer) {
    // 优化收起后的页面滚动位置
    const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const containerRect = accordionContainer.getBoundingClientRect();
    const containerTop = currentScrollTop + containerRect.top;
    
    // 如果当前滚动位置在折叠块下方，则滚动回折叠块顶部
    if (currentScrollTop > containerTop) {
      const targetPosition = Math.max(0, containerTop - this.headerHeight - 20);
      
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    }
  }

  setupIntersectionObserver(accordionContainer) {
    const summary = accordionContainer.querySelector('summary');
    if (!summary) return;

    // 如果已经存在观察器，先断开
    if (this.intersectionObservers.has(accordionContainer)) {
      this.intersectionObservers.get(accordionContainer).disconnect();
    }

    // 创建交叉观察器来检测标题是否进入粘性状态
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        // 只有当details处于open状态时才处理粘性效果
        if (accordionContainer.querySelector('details').open) {
          if (entry.target === summary) {
            // 判断summary是否到达粘性位置
            // entry.boundingClientRect.top <= this.headerHeight 表示summary顶部到达或超过header底部
            // entry.intersectionRatio < 1 表示summary的一部分或全部离开了rootMargin定义的区域
            if (entry.boundingClientRect.top <= this.headerHeight && entry.intersectionRatio < 1) {
              accordionContainer.classList.add('is-sticky');
            } else {
              accordionContainer.classList.remove('is-sticky');
            }
          }
        } else {
          // 如果details不是open状态，确保移除is-sticky类
          accordionContainer.classList.remove('is-sticky');
        }
      });
    }, {
      threshold: [0, 1], // 观察0%和100%可见性
      rootMargin: `-${this.headerHeight}px 0px 0px 0px` // 根元素边距，用于计算交叉区域
    });

    observer.observe(summary);
    this.intersectionObservers.set(accordionContainer, observer);
  }

  scrollToAccordion(accordionContainer) {
    const rect = accordionContainer.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const targetPosition = scrollTop + rect.top - this.headerHeight - 20;

    window.scrollTo({
      top: Math.max(0, targetPosition),
      behavior: 'smooth'
    });
  }

  addScrollListener() {
    let ticking = false;
    
    const scrollHandler = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          this.handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', scrollHandler, { passive: true });
  }

  handleScroll() {
    // 滚动处理逻辑（如果需要额外的滚动处理）
    // 目前主要依赖IntersectionObserver
  }

  handleResize() {
    // 窗口大小变化时重新初始化
    // 移除移动端限制
    // if (window.innerWidth > 750) {
    //   this.destroy();
    //   return;
    // }

    // 更新Header高度
    this.updateHeaderHeight();
    this.setCSSVariables();
    
    // 重新记录折叠块位置
    this.recordAccordionPositions();
    
    // 重新设置所有IntersectionObserver，因为rootMargin可能改变
    this.accordions.forEach(accordion => {
      this.setupIntersectionObserver(accordion.closest('.product__accordion'));
    });
  }

  observeHeaderChanges() {
    const header = document.querySelector('header.header') || 
                   document.querySelector('.header') || 
                   document.querySelector('header');
    
    if (!header) return;

    // 使用ResizeObserver监听Header大小变化
    if (window.ResizeObserver) {
      this.resizeObserver = new ResizeObserver(() => {
        this.updateHeaderHeight();
        this.setCSSVariables();
        // Header高度变化后，需要重新设置所有IntersectionObserver的rootMargin
        this.accordions.forEach(accordion => {
          this.setupIntersectionObserver(accordion.closest('.product__accordion'));
        });
      });
      
      this.resizeObserver.observe(header);
    }
  }

  destroy() {
    // 清理事件监听器和观察器
    this.accordions.forEach(accordion => {
      accordion.removeEventListener('toggle', this.handleToggle);
      const container = accordion.closest('.product__accordion');
      if (container) {
        this.deactivateSticky(container);
      }
    });

    window.removeEventListener('resize', this.handleResize);
    
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
    
    // 断开并清空所有IntersectionObserver
    this.intersectionObservers.forEach(observer => observer.disconnect());
    this.intersectionObservers.clear();

    this.accordionPositions.clear();
    this.isInitialized = false;
  }
}

// 自动初始化
document.addEventListener('DOMContentLoaded', () => {
  // 延迟初始化，确保其他脚本加载完成
  setTimeout(() => {
    window.stickyAccordion = new StickyAccordion();
  }, 100);
});

// 处理页面导航（如果使用了AJAX导航）
document.addEventListener('shopify:section:load', () => {
  if (window.stickyAccordion) {
    window.stickyAccordion.destroy();
  }
  setTimeout(() => {
    window.stickyAccordion = new StickyAccordion();
  }, 100);
});